export default __webpack_public_path__ + "resources/icons/n111-28f8.webp";